<script lang="ts">
	import { page } from '$app/state';
	import { userStore } from '$lib/stores/user';
	import { pathMatch } from '$lib/utils';
	import { signOut } from 'aws-amplify/auth';
	import { ChevronDown, ChevronUp, CircleUserRound, Star } from 'lucide-svelte';
	import { slide } from 'svelte/transition';

	interface Props {
		navItems: NavItem[];
		menuOpen?: boolean;
	}

	let { navItems, menuOpen = $bindable(false) }: Props = $props();

	let navEl: HTMLUListElement | undefined = $state();
	let selected = $state(-1);
	let userOpen = $state(false);

	let open = $derived(
		navItems.map((navItem, i) => {
			if (navItem.children) {
				return (
					selected === i ||
					(selected === -1 && navItems[i].children?.map((c) => c.url).includes(page.url.pathname))
				);
			} else {
				return false;
			}
		})
	);
</script>

<ul
	bind:this={navEl}
	transition:slide
	class="bg-white-pure text-gray-dark fixed top-[3.375rem] left-0 z-30 flex h-full w-full flex-col px-6 font-medium"
>
	{#if $userStore.signedIn}
		<li>
			<button
				onclick={() => (userOpen = !userOpen)}
				class="flex h-10 w-full items-center justify-between"
			>
				<div class="flex items-center">
					<CircleUserRound class="mr-2 w-6" />
					{$userStore.nickname}
				</div>
				{#if userOpen}
					<ChevronUp class="w-6" />
				{:else}
					<ChevronDown class="w-6" />
				{/if}
			</button>
		</li>
		{#if userOpen}
			<ul transition:slide class="flex flex-col font-normal">
				<li>
					<a href="/watchlist" class="index-bold flex h-10 items-center">
						<Star class="mr-2 w-4" />
						My Watchlist
					</a>
				</li>
				<li>
					<button
						onclick={async () => {
							await signOut();
							location.href = '';
						}}
						class="index-regular text-gray-dark flex h-10 items-center">Sign out</button
					>
				</li>
			</ul>
		{/if}
	{:else}
		<li>
			<a href="/signup" class="flex h-10 items-center">Create free account</a>
		</li>
	{/if}
	<hr class="border-gray-faint my-4" />
	{#each navItems as navItem, i}
		{#if navItem.children}
			<li>
				<button
					class="flex h-10 w-full items-center justify-between"
					onclick={(e) => {
						e.stopPropagation();
						selected = open[i] ? -2 : i;
					}}
				>
					{navItem.label}
					{#if open[i]}
						<ChevronUp class="w-6" />
					{:else}
						<ChevronDown class="w-6" />
					{/if}
				</button>
				{#if open[i]}
					<ul transition:slide class="flex flex-col font-normal">
						{#each navItem.children as navChild}
							<li class:active={pathMatch(page.url.pathname, navChild.url, navChild.exact)}>
								<a class="flex h-10 items-center" href={navChild.url}>
									{navChild.label}
								</a>
							</li>
						{/each}
					</ul>
				{/if}
			</li>
		{:else}
			<li class:active={pathMatch(page.url.pathname, navItem.url ?? '', navItem.exact)}>
				<a href={navItem.url} class="flex h-10 items-center">
					{navItem.label}
				</a>
			</li>
		{/if}
	{/each}
</ul>

<style lang="postcss">
	@reference '../../app.css';

	.active {
		@apply text-green-primary font-medium;
	}
</style>
